<template>
  <div :class="{ 'uk-form-controls': !$attrs.placeholder }">
    <input v-bind="$attrs" :type="type" :name="name" :value="value" @input="$emit('input', $event.target.value)" class="uk-input" :class="[{ 'uk-form-danger': error }, width, classes]" />
    <!--<small v-if="error" class="uk-text-danger">{{ error }}</small>-->
  </div>
</template>

<script>
export default {
  inject: ['$validator'],

  inheritAttrs: false,
  props: {
    value: {
      required: false,
      Type: String,
      default: '',
    },
    name: {
      required: true,
      Type: String,
    },
    type: {
      required: false,
      type: String,
      default: 'text',
    },
    error: {
      type: String,
      default: null,
    },
    width: {
      required: false,
      type: String,
      default: 'uk-width-1-1',
    },
    classes: {
      required: false,
      type: String,
      default: ''
    }
  },
  /*
  mounted() {
    if (this.val) {
      this.$emit('input', this.val)
    }
  },
  */
}
</script>
